import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Redirect, Link } from 'react-router-dom'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { login, recoverSession, setLanguage } from '../actions'
import { isAuthenticated, canRecover } from '../services/sessionService'
import { showAbout } from '../services/miscService'
import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'
import { Layout, Form, Input, Button, Spin, Menu, Dropdown, message } from 'antd';
const FormItem = Form.Item;
const { Content, Footer } = Layout;



const ERROR_WRONG_PASSWORD = 1
const ERROR_ACCOUNT_NOT_VALIDATED = 2
const ERROR_ACCOUNT_BLOCKED = 3
const ERROR_EMAIL_NOT_VALIDATED = 5



/**
 * Login view
 */

class Login extends Component {

    static propTypes = {
        session: PropTypes.object,
        login: PropTypes.func.isRequired,
        recoverSession: PropTypes.func.isRequired,
        setLanguage: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    state = {
        comboboxes: {},
        loading: false
    }

    loadComboboxes = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'settings'
        }).then((data) => {
            this.setState({
                comboboxes: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({ id: 'misc.unknownError' }))
            this.setState({ loading: false })
        })
    }

    componentWillMount() {
        const { session } = this.props

        if (!isAuthenticated(session)) {
            if (canRecover(session)) {
                if (!session.isRecovering) {
                    this.props.recoverSession()
                }
            }
        }
        this.loadComboboxes()
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ loading: true })
                this.props.login(values.email, values.password).then((response) => {
                    if (response.error) {
                        const { intl, history } = this.props
                        if (response.error.status === 429) {
                            message.warn(intl.formatMessage({ id: 'misc.tooManyRequests' }))
                        } else {
                            switch (response.error.code) {
                                case ERROR_WRONG_PASSWORD: message.error(intl.formatMessage({ id: 'login.wrongPassword' })); break;
                                case ERROR_ACCOUNT_NOT_VALIDATED:
                                    history.push({ pathname: '/message', state: { name: 'accountNotValidated' } })
                                    return
                                case ERROR_ACCOUNT_BLOCKED:
                                    history.push({ pathname: '/message', state: { name: 'accountBlocked' } })
                                    return
                                case ERROR_EMAIL_NOT_VALIDATED:
                                    history.push({ pathname: '/message', state: { name: 'emailNotValidated', userId: response.error.userId } })
                                    return
                                default: message.error(intl.formatMessage({ id: 'misc.unknownError' })); break;
                            }
                        }
                    }
                    this.setState({ loading: false })
                })
            }
        })
    }

    handleLanguageChange = (e) => this.props.setLanguage(e.key)


    render() {
        const { getFieldDecorator } = this.props.form;
        const { session, location, intl } = this.props;
        const { comboboxes, loading } = this.state;

        if (session.isRecovering && !loading) {
            return (<Layout style={{ background: '#fff', marginTop: '75px' }}><Spin size="large" /></Layout>)
        }
        if (session.user) {
            if (location.state && location.state.from) {
                return (<Redirect to={location.state.from} />)
            }
            return (<Redirect to={{ pathname: "/" }} />)
        }
        if (loading) {
            return (<Layout style={{ background: '#fff', marginTop: '75px' }}><Spin size="large" /></Layout>)
        }

        return (
            <Layout style={{ minHeight: '100vh', background: '#fff' }}>

                <Dropdown overlay={<Menu onClick={this.handleLanguageChange}>{comboboxes.language.map((option) => <Menu.Item key={option.key}>{option.value}</Menu.Item>)}</Menu>}>
                    <FaIcon icon="language" size="2x" style={{ position: 'absolute', right: 10, top: 5 }} />
                </Dropdown>

                <Content style={{ margin: '16px' }}>
                    <Form onSubmit={this.handleSubmit} className="login-form">
                        <h1><FormattedMessage id="login.title" /></h1>
                        <FormItem>
                            {getFieldDecorator('email', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'login.emailRequired' }) }],
                            })(<Input prefix={<FaIcon icon="user" />} placeholder={intl.formatMessage({ id: 'login.email' })} />)}
                        </FormItem>
                        <FormItem>
                            {getFieldDecorator('password', {
                                rules: [{ required: true, message: intl.formatMessage({ id: 'login.passwordRequired' }) }],
                            })(<Input prefix={<FaIcon icon="lock" />} type="password" placeholder={intl.formatMessage({ id: 'login.password' })} />)}
                        </FormItem>
                        <FormItem>
                            <Button type="primary" htmlType="submit" className="login-form-button" loading={loading}><FormattedMessage id="login.login" /></Button>
                            <div style={{ textAlign: "right" }}><FormattedMessage id="login.or" /> <Link to="/register"><FormattedMessage id="login.register" /></Link></div>
                            {/*<div style={{textAlign: "right"}}><Link to="password-recovery"><FormattedMessage id="login.forgotten" /></Link></div>*/}
                        </FormItem>
                    </Form>
                </Content>

                <Footer style={{ textAlign: 'center', background: '#f8f8f8' }}>
                    &copy; 2020 - <FormattedMessage id="footer.createdBy" /> <a href="https://www.neoxis.be"><FaIcon icon="code" /> Neoxis</a>
                    <div style={{ float: "right" }}><FaIcon icon="info-circle" style={{ cursor: "pointer" }} onClick={() => showAbout(intl)} /></div>
                </Footer>

            </Layout>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default injectIntl(withRouter(connect(mapStateToProps, {
    login,
    recoverSession,
    setLanguage
})(Form.create()(Login))))


// WEBPACK FOOTER //
// ./src/containers/Login.js